import { useState } from "react";
import TimerRing from "../components/TimerRing";
import YarningRing from "../components/YarningRing";
import QuizBars from "../components/QuizBars";
import TopBanner from "../components/TopBanner";
import AgendaSidebar, { AgendaItem } from "../components/AgendaSidebar";

import avatarAlex from "../assets/images/avatar-alex.jpeg";
import avatarJordan from "../assets/images/avatar-jordan.jpeg";
import avatarMaya from "../assets/images/avatar-maya.jpeg";
import avatarSara from "../assets/images/avatar-sara.jpeg";

type View = "educator" | "student";

export default function InSessionDashboardPage() {
  const [view, setView] = useState<View>("educator");

  const participants = [
    { id: 1, name: "You", avatar: avatarAlex },
    { id: 2, name: "Ella", avatar: avatarJordan },
    { id: 3, name: "Kai", avatar: avatarMaya },
    { id: 4, name: "Lily", avatar: avatarSara },
  ];

  const agenda: AgendaItem[] = [
    { title: "Welcome & Warm-up", duration: 5 * 60 },
    { title: "Yarning Circle", duration: 10 * 60 },
    { title: "Mini Quiz", duration: 8 * 60 },
    { title: "Group Activity", duration: 15 * 60 },
    { title: "Wrap-up", duration: 5 * 60 },
  ];

  return (
    <div className="mx-auto max-w-7xl space-y-8">
      <TopBanner>
        <h1 className="text-xl font-semibold">In-Session Dashboard</h1>

        <div className="ml-auto flex items-center gap-2">
          <button
            onClick={() => setView("educator")}
            className={
              "rounded-md px-3 py-1.5 text-sm font-medium " +
              (view === "educator"
                ? "bg-primary text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600")
            }
          >
            Educator View
          </button>
          <button
            onClick={() => setView("student")}
            className={
              "rounded-md px-3 py-1.5 text-sm font-medium " +
              (view === "student"
                ? "bg-primary text-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600")
            }
          >
            Student View
          </button>
        </div>
      </TopBanner>

      {/* responsive grid as per spec */}
      <div className="grid grid-cols-1 gap-8 md:grid-cols-[240px_1fr]">
        {/* left column */}
        <div className="space-y-8">
          {/* Timer */}
          <section className="flex flex-col items-center rounded-lg bg-white p-6 shadow-sm dark:bg-gray-800">
            <TimerRing size={view === "student" ? 160 : 220} />
          </section>

          {/* Yarning circle */}
          <section className="rounded-lg bg-white p-6 shadow-sm dark:bg-gray-800">
            <YarningRing
              participants={participants}
              educatorMode={view === "educator"}
            />
          </section>
          {/* Agenda */}
          <section className="rounded-lg bg-white p-4 shadow-sm dark:bg-gray-800">
            <h3 className="mb-2 text-sm font-semibold text-gray-900 dark:text-gray-100">
              Agenda
            </h3>
            <AgendaSidebar items={agenda} educatorMode={view === "educator"} />
          </section>
        </div>

        {/* right column */}
        <section className="rounded-lg bg-white p-6 shadow-sm dark:bg-gray-800">
          <QuizBars
            question="How many continents are there on Earth?"
            options={[
              { id: "A", text: "5" },
              { id: "B", text: "6" },
              { id: "C", text: "7" },
              { id: "D", text: "8" },
            ]}
            correctId="C"
            educatorMode={view === "educator"}
          />
        </section>
      </div>
    </div>
  );
}
